/**
 * Recommendations V2 Web Component
 * Handles product recommendations with add to cart functionality
 */

if (!customElements.get('recommendations-v2')) {
  class RecommendationsV2 extends HTMLElement {
    connectedCallback() {
      this.bindEvents();
      this.init();
    }

    bindEvents() {
      this.addEventListener('click', (e) => {
        const addBtn = e.target.closest('.js-add-to-cart');
        if (addBtn) {
          e.preventDefault();
          this.addToCart(addBtn);
        }
      });
    }

    async init() {
      const { productId, url } = this.dataset;
      if (!productId || !url) return;

      try {
        const fetchUrl = `${url}&product_id=${productId}`;
        const response = await fetch(fetchUrl);
        if (!response.ok) throw new Error(`HTTP ${response.status}`);

        const tmpl = document.createElement('template');
        tmpl.innerHTML = await response.text();

        const el = tmpl.content.querySelector('recommendations-v2');
        if (el && el.hasChildNodes()) {
          this.innerHTML = el.innerHTML;
        }

        if (window.initLazyImages) {
          window.initLazyImages();
        }
      } catch (error) {
        console.error('Failed to fetch recommendations:', error);
      }
    }

    async addToCart(button) {
      const variantId = button.dataset.variantId;
      if (!variantId) return;

      button.classList.add('is-loading');

      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: variantId,
            quantity: 1,
          }),
        });

        if (!response.ok) throw new Error('Failed to add to cart');

        // Refresh cart drawer
        document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh'));
        document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open'));
      } catch (error) {
        console.error('Add to cart error:', error);
      } finally {
        button.classList.remove('is-loading');
      }
    }
  }

  customElements.define('recommendations-v2', RecommendationsV2);
}
